export default __webpack_public_path__ + "static/media/refill_2.f9013ef3.wav";